<script>
import StatewideMake from "@/views/statewide/statewide-make.vue";
import StatewideAddParts from "@/views/statewide/statewide-add-parts.vue";
import Axios from "axios";
import {appConfig} from "../../config";

export default {
  name: "statewide-main",
  components: { StatewideAddParts, StatewideMake },
  data() {
    return{
      checkedMake: null,
      isAuth: false,
      username: '',
      password: '',
      isClickedSignIn: false,
      isUsernameInFocus: false,
      isPasswordInFocus: false,
      signInErrorType: null,
    }
  },
  methods: {
    goToForgotYourPassword() {
      document.location.replace(appConfig.psAppUrl + '/stw/forgot/password');
    },
    goToForgotYourUsername() {
      document.location.replace(appConfig.psAppUrl + '/stw/forgot/username');
    },
    signIn() {
      this.isClickedSignIn = true
      if (_.isEmpty(this.username) || _.isEmpty(this.password)) {
        return
      }
      Axios.post('/stw/auth', {
        username: this.username,
        password: this.password
      }).then((r) => {
        if (r?.data?._errorCode) {
          this.signInErrorType = r.data._errorCode
        }
        if (r?.data?._status && r?.data?.code) {
          document.location.replace(appConfig.appURL + '/a-stw/' + r.data.code);
        }
      })
    },
    _isEmpty(v) {
      return _.isEmpty(v)
    }
  }
}
</script>

<template>
  <div>
    <div class="wrapper-statewide">
      <header>
        <div class="d-flex header-block">
          <div @click="checkedMake = false" class="header-block-logo"><img src="../../../public/auto-logo/statewide-logo.png" alt=""></div>
          <div style="position: relative">
            <button @click="isAuth = !isAuth" class="header-number">SIGN IN</button>
            <div v-if="isAuth" class="auth">
              <div class="auth-username">
                <div class="auth-title">Username</div>
                <input v-model="username" class="auth-input" type="text" @focus="isUsernameInFocus = true" @blur="isUsernameInFocus = false">
                <div class="auth-help" @click="goToForgotYourUsername"><span>Forgot your username?</span></div>
                <div v-if="_isEmpty(username) && isClickedSignIn && !isUsernameInFocus" class="error-text">Username must not be empty</div>
                <div v-if="signInErrorType == 2" class="error-text">This Username is not confirmed</div>
                <div v-if="signInErrorType == 3" class="error-text">We could not find that Username</div>
              </div>
              <div class="auth-password">
                <div class="auth-title">Password</div>
                <input v-model="password" class="auth-input" type="password" @focus="isPasswordInFocus = true" @blur="isPasswordInFocus = false">
                <div class="auth-help" @click="goToForgotYourPassword"><span>Forgot your password?</span></div>
                <div v-if="_isEmpty(password) && isClickedSignIn && !isPasswordInFocus" class="error-text">Username must not be empty</div>
                <div v-if="signInErrorType == 1" class="error-text">The password entered is incorrect</div>
              </div>
              <div class="auth-checkbox">
                <label class="form-check-inline checkbox" style="margin-right: 0">
                  <input class="form-check-input"
                         type="checkbox"
                  >
                  <span class="icon clickable" style="border: 1px solid #552a77; height: 26px; width: 26px"
                  ><i class='bx bx-check' style="position: absolute"></i></span>
                </label>
                <span style="font-size: 13px; font-weight: 500; position: relative; top: -7px">Remember this device</span>
              </div>
              <button @click="signIn" class="btn btn-sign-in" style="width: 100%">Sign In</button>
            </div>
          </div>
        </div>
      </header>
      <div>
        <StatewideMake v-if="!checkedMake" @selected="v => checkedMake = v"></StatewideMake>
        <StatewideAddParts v-else :selectedMake="checkedMake"></StatewideAddParts>
      </div>
    </div>
    <footer>
      <div class="footer-block d-flex">
        <div class="footer-logo">
          <img src="../../../public/auto-logo/statewide-logo-white.png" alt="">
        </div>
        <div class="footer-main d-flex">
          <div class="footer-info">
            <div class="footer-info-title">
              PARTS
            </div>
            <div class="footer-info-item">
              Spare Parts
            </div>
            <div class="footer-info-item">
              FAQ`S
            </div>
          </div>
          <div class="footer-info">
            <div class="footer-info-title">
              DISCOVER
            </div>
            <div class="footer-info-item">
              About Statewide
            </div>
            <div class="footer-info-item">
              Join our community
            </div>
          </div>
          <div class="footer-info">
            <div class="footer-info-title">
              FIND US
            </div>
            <div class="footer-info-item">
              About Statewide
            </div>
            <div class="footer-info-item">
              Call
            </div>
            <div class="footer-info-item">
              Email
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<style scoped>
.header-block-logo{
  cursor: pointer;
}
.auth{
  position: absolute;
  right: 40px;
  border-radius: 5px;
  z-index: 100;
  border: 2px solid #552a77;
  background-color: white;
  padding: 10px 20px;
  color: black;
  font-family: "Roboto", serif;
}
.auth .auth-title{
  font-size: 17px;
  font-weight: 600;
  margin: 5px 0;
}
.auth .auth-input{
  height: 32px;
  padding: 5px 10px;
  line-height: 16px;
  font-size: 12px;
  font-weight: 600;
  width: 250px;
  border: 1px solid rgba(35, 35, 35, 0.65);
}
.auth .auth-help{
  font-size: 13px;
  text-align: right;
  font-weight: 500;
  margin-top: 5px;
}
.auth .auth-help span{
  color: rgb(88, 43, 121);
}
.auth .auth-help span:hover{
  cursor: pointer;
}
.auth .auth-checkbox{
  margin-top: 10px;
}
.auth label.checkbox>input[type="checkbox"]:checked+span.icon{
  background-color: #6f309f;
}
.auth .btn-sign-in{
  background-color: #6f309f;
  color: white;
  border-radius: 3px;
  border: 2px solid #6f309f;
  font-weight: 900;
  font-size: 15px;
  padding: 6px 10px;
  margin-top: 8px;
  margin-bottom: 10px;
}
.auth .btn-sign-in:hover{
  background-color: #76439d;
}
.header-block .header-block-logo img{
  width: 220px;
}
.header-block .quote-pricing-progress >>> .wizard__step:last-child .wizard__step__line{
  border-radius: 5px 5px 5px 5px;
}
.header-block .quote-pricing-progress >>> .wizard__step:last-child .wizard__step__line{
  border-radius: 5px 5px 5px 5px;
}
.header-block .quote-pricing-progress >>> .wizard__divider {
  display: none !important;
}
.header-block .quote-pricing-progress {
  font-family: "Roboto", serif;
}
.wrapper-statewide{
  font-family: "Asap", serif;
  font-weight: 900;
  max-width: 1200px;
  margin: 7px auto;
  min-height: calc(100vh - 250px);
}
.header-block{
  font-size: 25px;
  color: #ebc018;
  justify-content: space-between;
}
.header-number{
  margin: 20px 40px 3px 0;
  font-size: 22px;
  font-weight: 600;
  background-color: #76439d;
  color: white;
  border: 2px solid #552a77;
  border-radius: 5px;
  height: 50px;
  padding: 0 30px;
}
.header-number:hover{
  background-color: #623883;
  color: white;
}
.main-title{
  font-size: 66px;
  color: rgb(88, 43, 121);
  text-align: center;
  margin-top: 30px;
  text-transform: uppercase;
  letter-spacing: 2px;
}
.main-subtitle{
  font-size: 44px;
  color: rgb(0, 0, 0);
  text-align: center;
  font-weight: 600;
  margin-top: 30px;
  letter-spacing: 1.5px;
}
.main-subtitle span{
  font-weight: 800;
}
.main-text{
  font-size: 30px;
  color: rgb(88, 43, 121);
  text-align: center;
  margin-top: 50px;
  font-weight: 600;
  letter-spacing: 1.2px;
  margin-bottom: 50px;
}
.main-text span{
  font-family: "Inter", Arial, Helvetica, sans-serif;
}
.card-statewide img{
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
footer{
  background-color: #572b78;
  font-family: "Asap", serif;
}
.footer-block{
  max-width: 1200px;
  margin: 0 auto;
  height: 250px;
  padding: 40px 0;
}
.footer-logo{
  width: 40%;
}
.footer-logo img{
  width: 220px;
}
.footer-main{
  width: 60%;
}
.footer-info{
  width: 33.333%;
}
.footer-info-title{
  color: #ebc018;
  font-size: 25px;
  line-height: 30px;
  font-weight: 700;
  letter-spacing: 1.2px;
  margin-bottom: 50px;
}
.footer-info-item{
  color: white;
  font-weight: 500;
  font-size: 22px;
  line-height: 30px;
  margin-bottom: 15px;
}
.footer-info:last-child{
  padding-left: 40px;
}
@media (max-width: 1400px) {
  .wrapper-statewide {
    padding: 20px;
    width: 100%;
  }
}
@media (max-width: 1200px) {
  .header-block .quote-pricing-progress >>> .steps.mobile-scroll .wizard__steps{
    min-width: 250px;
  }
  .header-block .quote-pricing-progress >>> .steps{
    min-width: 250px;
  }
  .wrapper-statewide{
    margin-top: 0;
  }
  .footer-info-title{
    font-size: 18px;
    margin-bottom: 20px;
  }
  .footer-info-item{
    font-size: 15px;
    margin-bottom: 10px;
  }
  .footer-block{
    padding: 40px 20px;
  }
  .footer-logo{
    width: 30%;
  }
  .footer-main{
    width: 70%;
  }
  .footer-logo img{
    width: 150px;
  }
}
@media (max-width: 700px) {
  .header-block .header-block-logo img{
    padding-top: 15px;
    width: 110px;
  }
  .header-number{
    font-size: 16px;
    height: 40px;
    margin-right: 10px;
  }
  .footer-logo img{
    width: 80px;
  }
}
@media (max-width: 530px) {
  .header-number{

  }
  .footer-info-title{
    font-size: 15px;
    margin-bottom: 15px;
  }
  .footer-info-item{
    font-size: 13px;
    margin-bottom: 8px;
  }
  .footer-info:last-child{
    padding-left: 10px;
  }
}
@media (max-width: 400px) {
  .header-block .header-block-logo img{
    padding-top: 20px;
    width: 80px;
  }
  .header-number{
    height: 35px;
    margin-right: 0;
  }
}
</style>
